module.exports = __webpack_public_path__ + "static/media/paper-girls-vol3.e3138a92.jpg";